import { render, staticRenderFns } from "./PlayerTotalResult.vue?vue&type=template&id=709de39c&"
import script from "./PlayerTotalResult.vue?vue&type=script&lang=js&"
export * from "./PlayerTotalResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports